import { z } from "zod";

export const pushConfigSchema = z.object({
  enabled: z.boolean(),
  /** VAPID public key for PushManager.subscribe(); null when push is switched off. */
  publicKey: z.string().nullable(),
});
export type PushConfig = z.infer<typeof pushConfigSchema>;

/** The JSON of a browser PushSubscription. Which hosts are accepted is checked by the API. */
export const pushSubscriptionInputSchema = z.object({
  endpoint: z.url().max(2_000),
  keys: z.object({
    p256dh: z.string().min(20).max(200),
    auth: z.string().min(8).max(100),
  }),
});
export type PushSubscriptionInput = z.infer<typeof pushSubscriptionInputSchema>;

export const pushUnsubscribeSchema = z.object({ endpoint: z.url().max(2_000) });

export const pushDevicesSchema = z.object({ devices: z.number().int() });

export const pushTestResultSchema = z.object({
  sent: z.number().int(),
  removed: z.number().int(),
});

/** What the service worker receives and shows; `url` is always a path inside the app. */
export const pushNotificationSchema = z.object({
  title: z.string(),
  body: z.string(),
  url: z.string().startsWith("/"),
  tag: z.string(),
});
export type PushNotification = z.infer<typeof pushNotificationSchema>;
